import { createAction } from '@reduxjs/toolkit'

import { isPresent } from 'lib/Helper'

/**
 *
 * It will prepare the filter payload by sending in the value and
 * segment id. if the filter value is present then it should sent the
 * segment id  else do not send the segment id ( reset the filter )
 *
 * @param value
 * @param segment_id
 * @returns payload : { value , participant_segment_id }
 */
export const prepareFilterPayload = (
  value: string,
  segment_id: string,
  index?: number,
) => {
  const participant_segment_id: number | null =
    isPresent(value) && parseInt(segment_id)
  return {
    payload: {
      value,
      participant_segment_id,
      index,
    },
  }
}

export const resetParticipantContext = createAction(
  'participants/resetParticipantContext',
)
